
export const GlobalConstant = {
   ErrorMsg500:"Unable to process request please try again later."
};
  